import styled, { css } from 'styled-components'
import { Colors, Shadows, Spacing } from 'cio-design-library/design-tokens'
import Media from 'builder/styles/media'
import { SegmentControl } from 'builder/components/SegmentControls'
import { EditorPanelSwitcherWrapper } from '../styles'

export const TabsContainer = styled.div<{ $isAiWriterOpen?: boolean }>`
  max-height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 16px 10px 12px;
  background-color: ${Colors.White};
  border-bottom: 1px solid ${Colors.Neutral15};
  transition: all 350ms ease-in-out;

  ${props =>
    props.$isAiWriterOpen &&
    css`
      max-height: 0;
      padding: 0;
      opacity: 0;
      border-bottom: none;
      visibility: hidden;
    `}

  ${Media.Tablet`
    flex-direction: column;
    align-items: stretch;
    padding: 0;
  `};
`

export const NavigationContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 16px 10px 12px;
  background-color: ${Colors.White};
  border-bottom: 1px solid ${Colors.Neutral15};
  border-radius: 0 0 12px 12px;

  ${Media.Tablet`
    flex-direction: column;
    align-items: stretch;
    padding: 0;
    border-bottom: none;
    margin-bottom: 4px;
  `};
`

export const TabletTopRow = styled.div`
  display: none;

  ${Media.Tablet`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 16px 0;
  `};
`

export const TabletTitleRow = styled.div`
  display: none;

  ${Media.Tablet`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: ${Spacing.M} 0 16px;
    position: relative;
    height: 50px;
  `};
`

export const TabletTitleCenter = styled.div`
  display: none;

  ${Media.Tablet`
    display: flex;
    flex-direction: column;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    align-items: center;
    gap: 8px;
  `};
`

export const TabletEditIcon = styled.div`
  display: none;

  ${Media.Tablet`
    display: flex;
    align-items: center;
    position: absolute;
    right: 16px;
    top: -5px;
  `};
`

export const TabletLeftSection = styled.div`
  display: none;

  ${Media.Tablet`
    display: flex;
    align-items: center;
    gap: 12px;
  `};
`

export const SidebarToggleButton = styled.div`
  position: absolute;
  left: ${Spacing.M};
  padding: 8px;
  cursor: pointer;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: ${Colors.Blue10};
    svg {
      color: ${Colors.Blue50};
      fill: ${Colors.Blue50};
    }
  }

  svg {
    width: 24px;
    height: 24px;
    color: ${Colors.Neutral60};
    transition: color 0.2s ease;
  }

  ${Media.Tablet`
    position: static;
  `};

  ${Media.Phone`
    display: none;
  `};
`

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
`

export const ResumeTitleContainer = styled.div`
  position: absolute;
  left: 70px;
  display: flex;
  align-items: center;
  z-index: 200;
  max-width: 335px;
  width: 100%;

  ${TitleWrapper}:hover + div:not([data-editing="true"]) {
    transform: translateX(16px);
  }

  ${Media.Laptop`
    max-width: 190px;
    
    ${TitleWrapper}:hover + div:not([data-editing="true"]) {
      transform: none;
      opacity: 0;
    }
  `}
`

export const LanguageSelectContainer = styled.div<{ $isEditing: boolean }>`
  display: flex;
  align-items: center;
  transition: transform 0.2s ease, opacity 0.2s ease;
  opacity: ${props => (props.$isEditing ? 0 : 1)};

  ${Media.Laptop`
    transition: opacity 0.2s ease;
  `}
`

export const DownloadButtonContainer = styled.div`
  position: absolute;
  right: 80px;
  display: flex;
  align-items: center;
  z-index: 200;

  ${Media.Tablet`
    display: none;
  `};
`

export const UserSettingsContainer = styled.div`
  position: absolute;
  right: ${Spacing.M};
  display: flex;
  align-items: center;
  z-index: 200;
  cursor: pointer;
`

export const TabTextContainer = styled.span`
  position: relative;
`

export const TabBadge = styled.span`
  position: absolute;
  top: -8px;
  right: -35px;
  font-size: 11px;
  background: ${Colors.Blue50};
  color: white;
  padding: 0 2px;
  border-radius: 2px;
  font-weight: 600;
  transform: rotate(32deg);
  line-height: 13px;
`

export const StyledEditorPanelSwitcherWrapper = styled(EditorPanelSwitcherWrapper)<{
  $isStickyState?: boolean
  $canScrollTop?: boolean
}>`
  margin-bottom: 0;
  border-radius: 12px;
  transition: border-radius 0.2s ease-out, box-shadow 0.2s ease-out;

  ${props =>
    props.$isStickyState &&
    css`
      border-top-left-radius: 0;
      border-top-right-radius: 0;
    `}

  ${props =>
    props.$canScrollTop &&
    css`
      box-shadow: ${Shadows.lightWithBorderShadowMid};
    `}
`

export const StyledSegmentControl = styled(SegmentControl)`
  min-width: 103px;
  padding: ${Spacing['2XS']} ${Spacing.XS};

  ${Media.Tablet`
    min-width: 0;
    flex: 1;
  `};
`
